import { ChangeEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { set } from "../../../store/ProjectOld/BasicInfo";
import FileUploadButton from "../../../components/FileUploadButton";

function Incentive() {
  // const dispatch = useDispatch();
  // const opportunityInfo = useSelector(
  //   (state: RootState) => state.opportunity.opportunityInfo
  // );

  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    //dispatch(set({ [e.target.name]: e.target.value }));
  };

  return (
    <>
      <h2 className="mt-0 text-primaryColor-normal">Incentives</h2>
      <div className="mb-4 flex flex-col text-sm justify-between">
        <label className="leading-7  text-gray-600">Oppotunity Zone</label>
        <div className="flex justify-between items-center">
          <div className=" flex-grow bg-white px-4 py-2 text-center mr-2">
            No File Chosen
          </div>
          <div className="bg-white px-4 py-2 text-center transform hover:scale-110">
            <FileUploadButton changeHandler={changeHandler} />
          </div>
        </div>
      </div>

      <div className="mb-4 flex flex-col text-sm justify-between">
        <label className="leading-7 text-gray-600">
          State Historic Tax Credits
        </label>
        <div className="flex justify-between items-center">
          <div className=" flex-grow bg-white px-4 py-2 text-center mr-2">
            No File Chosen
          </div>
          <div className="bg-white px-4 py-2 text-center transform hover:scale-110">
            <FileUploadButton changeHandler={changeHandler} />
          </div>
        </div>
      </div>

      <div className="mb-4 flex flex-col text-sm justify-between">
        <label className="leading-7 text-gray-600">
          Fedral Historic Tax Credits
        </label>
        <div className="flex justify-between items-center">
          <div className=" flex-grow bg-white px-4 py-2 text-center mr-2">
            No File Chosen
          </div>
          <div className="bg-white px-4 py-2 text-center transform hover:scale-110">
            <FileUploadButton changeHandler={changeHandler} />
          </div>
        </div>
      </div>

      <div className="mb-4 flex flex-col text-sm justify-between">
        <label className="leading-7 text-gray-600">
          New Market Tax Credits
        </label>
        <div className="flex justify-between items-center">
          <div className=" flex-grow bg-white px-4 py-2 text-center mr-2">
            No File Chosen
          </div>
          <div className="bg-white px-4 py-2 text-center transform hover:scale-110">
            <FileUploadButton changeHandler={changeHandler} />
          </div>
        </div>
      </div>

      <div className="mb-4 flex flex-col text-sm justify-between">
        <label className="leading-7 text-gray-600">QCT or DDA</label>
        <div className="flex justify-between items-center">
          <div className=" flex-grow bg-white px-4 py-2 text-center mr-2">
            No File Chosen
          </div>
          <div className="bg-white px-4 py-2 text-center transform hover:scale-110">
            <FileUploadButton changeHandler={changeHandler} />
          </div>
        </div>
      </div>
    </>
  );
}

export default Incentive;
